export default "__VITE_ASSET__Dq1IFsJZ__"